import { Component, Input, ViewEncapsulation } from '@angular/core';
import { LucideModule } from '@shared/modules/lucide.module';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
	selector: 'app-confirm-dialog',
	imports: [ConfirmDialogModule, LucideModule],
	templateUrl: './confirm-dialog.component.html',
	styleUrl: './confirm-dialog.component.scss',
	encapsulation: ViewEncapsulation.None,
})
export class ConfirmDialogComponent {
	@Input() key?: string; // Allows multiple confirm dialogs with different configurations
}
